<fin-continue-reading>
  <ng-content></ng-content>
</fin-continue-reading>
